import styled from '@emotion/styled';
import { useState } from 'react';
import { SliderPicker } from 'react-color';

type Props = {
  value?: string | null;
  onChange?: (value?: string) => void;
};

export default function ColorPicker(props: Props) {
  const [color, setColor] = useState(props.value || 'transparent');

  return (
    <Root>
      <Preview backgroundColor={color}>{color}</Preview>
      <SliderPicker
        color={color}
        onChange={(color) => setColor(color?.hex)}
        onChangeComplete={(color) => props.onChange?.(color?.hex)}
      />
    </Root>
  );
}

const Root = styled.div`
  flex: 1;
  margin-left: ${({ theme }) => theme.spacing(1)};
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};

  .block-picker {
    box-shadow: none !important;

    & > div:nth-child(2) {
      max-height: 48px;
    }
  }
`;

const Preview = styled.div<{ backgroundColor?: string }>`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${({ theme }) => theme.spacing(1)};
  height: 32px;
  background-color: ${({ backgroundColor }) => backgroundColor};
  box-sizing: border-box;
`;
